const SoccerSvg = (props) => (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="121.51px"
      height="121.511px"
      viewBox="0 0 121.51 121.511"
      xmlSpace="preserve"
      style={{ enableBackground: 'new 0 0 121.51 121.511' }}
      {...props}
    >
      <g>
        <g>
          <path
            d="M50.116,78.373c1.407-1.311,2.471-3.025,2.933-5.182l2.508-11.705c2.988,2.607,7.471,4.384,14.276,4.384
              c3.083,0,5.581-2.499,5.581-5.581s-2.498-5.581-5.581-5.581c-8.561,0-8.806-3.124-9.396-10.67
              c-0.107-1.369-0.218-2.784-0.414-4.165c-0.037-0.26-0.098-0.51-0.167-0.755c-0.474-4.417-3.961-8.051-7.603-9.816
              c0,0-1.386-0.761-2.968-1.063c-1.514-0.289-3.268-0.299-3.268-0.299l-0.042-0.002c-1.549,0.045-3.184,0.345-4.738,0.911
              c-0.465,0.065-0.93,0.184-1.383,0.373c-0.65,0.271-16.059,6.769-27.436,16.997c-2.292,2.061-2.479,5.589-0.418,7.881
              c1.102,1.226,2.623,1.85,4.151,1.85c1.329,0,2.663-0.472,3.729-1.431c3.737-3.36,8.077-6.305,12.045-8.676l-4.676,21.822
              c-0.707,3.301,0.33,6.325,2.293,8.714c-0.916,8.861-2.363,19.01-3.217,21.102c-0.925,1.873-6.905,7.602-12.799,12.258
              c-2.857,2.259-3.345,6.406-1.087,9.265c1.302,1.647,3.231,2.508,5.181,2.508c1.431,0,2.871-0.463,4.082-1.419
              c4.273-3.374,14.466-11.839,16.806-17.556c1.099-2.683,2.088-8.349,2.856-13.894l19.582,25.549
              c1.299,1.695,3.258,2.584,5.24,2.584c1.399,0,2.812-0.443,4.007-1.36c2.893-2.216,3.439-6.356,1.225-9.248L50.116,78.373z"
            style={{ fill: 'currentColor' }}
          />
          <circle cx="55.454" cy="14.376" r="14.376" style={{ fill: 'currentColor' }} />
          <path
            d="M99.393,76.6c-6.368,0-11.549,5.184-11.549,11.551s5.181,11.549,11.549,11.549c6.367,0,11.55-5.182,11.55-11.549
              S105.76,76.6,99.393,76.6z M95.846,79.462c..."
            style={{ fill: 'currentColor' }}
          />
          {/* Truncated for brevity. You can paste the full path data here as needed. */}
        </g>
      </g>
    </svg>
  );
  
  export default SoccerSvg;
  